<template>
  <div>
    <div class="my-4">
      <h2>{{ reviewStore.settings.feedbackQuestion }}</h2>
    </div>
    <el-button
      class="mr-6"
      type="success"
      size="large"
      plain
      @click="showReviewOptions = true"
      >Yes!</el-button
    >
    <el-button type="warning" size="large" plain @click="navToFinish"
      >No</el-button
    >

    <div v-if="showReviewOptions">
      <div class="my-4">
        <h2>Where would you like to leave a review?</h2>
      </div>
      <div class="flex flex-col items-center">
        <div
          v-for="(option, index) in reviewOptions"
          :key="index"
          class="w-1/3 flex justify-center items-center"
        >
          <div
            class="px-4 border rounded-full bg-gray-400 my-4 min-w-[200px] text-black font-bold"
            plain
            @click="navToReview(option.link)"
            v-if="option.show"
          >
            <div class="flex py-2 items-center cursor-pointer">
              <div class="pl-2">
                <GoogleLogo v-if="option.name == 'Google'" />
                <FacebookLogo v-else-if="option.name == 'Facebook'" />
                <YelpLogo v-else-if="option.name == 'Yelp'" />
                <div v-else></div>
              </div>
              <span class="pl-6">
                {{ option.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import { useReview } from "@/stores";
import GoogleLogo from "@/components/GoogleLogo.vue";
import FacebookLogo from "@/components/FacebookLogo.vue";
import YelpLogo from "@/components/YelpLogo.vue";

const reviewStore = useReview();
const showReviewOptions = ref(false);

const extractDomainName = (urlString) => {
  if (!urlString.startsWith("http://") && !urlString.startsWith("https://")) {
    urlString = "https://" + urlString;
  }
  try {
    const url = new URL(urlString);
    return url.hostname;
  } catch (e) {
    console.error("Invalid URL", e);
    return "Invalid URL";
  }
};

const reviewOptions = ref([
  {
    name: "Google",
    link: reviewStore.settings.companyReviewLink,
    show: reviewStore.settings.companyReviewLink.includes("google.com"),
  },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com",
  // },
  // {
  //   name: "Yelp",
  //   link: "https://www.yelp.com",
  // },1
  {
    name: extractDomainName(reviewStore.settings.companyReviewLink),
    link: reviewStore.settings.companyReviewLink,
    show: !reviewStore.settings.companyReviewLink.includes("google.com"),
  },
]);

const navToReview = (link) => {
  reviewStore.recordClick("choiceReviewButtonClicked", "yes");
  // let url = reviewStore.settings.companyReviewLink;
  let url = link;
  if (!url.startsWith("http://") && !url.startsWith("https://")) {
    url = "http://" + url;
  }
  window.open(url, "_blank");
  setTimeout(() => {
    // askFeedback.value = false;
    if (reviewStore.invoiceStatus === "unpaid") {
      reviewStore.currentComponent = "PaymentOptions";
    } else {
      reviewStore.currentComponent = "ThankYou";
    }
  }, 1000);
};

const navToFinish = () => {
  reviewStore.recordClick("choiceReviewButtonClicked", "no");
  if (reviewStore.invoiceStatus === "unpaid") {
    reviewStore.currentComponent = "PaymentOptions";
  } else {
    reviewStore.currentComponent = "ThankYou";
  }
};
</script>
<style scoped></style>
